__turbopack_context__.v({
  "className": "fraunces_3d0e4fe8-module__4ihMTq__className",
});
